import React from 'react'
import FinishDemandPanel from "./FinishDemandPanel";

function Index(
    {
        expanded
    }) {
    return (expanded && <FinishDemandPanel/>)
}


export default Index;